export default "__VITE_ASSET__d4623f32__"